import React, { useContext, useState, useEffect } from "react";
import "../rating/rating.css";
import { AiFillStar } from "react-icons/ai";
import axios from "axios";
import RatingContext from "../RatingContext";

const Tags = (props) => {
  // const { ratings, setRatings } =

  // const { ratingAverage, setRatingAverage } = useContext(RatingContext);
  // const [Loading, setLoading] = useState(false);

  // const user = JSON.parse(localStorage.getItem("user"));
  // const user_id = user.user._id;
  // const token = user.token;

  // const [data, setData] = useState(null);

  // const [Val1, setVal1] = useState(0);
  // const [Val2, setVal2] = useState(0);
  // const [Val3, setVal3] = useState(0);
  // const [Val4, setVal4] = useState(0);
  // const [Val5, setVal5] = useState(0);
  // const [Val6, setVal6] = useState(0);
  // const [Val7, setVal7] = useState(0);
  // const [Val8, setVal8] = useState(0);
  // const [Val9, setVal9] = useState(0);
  // const [Val10, setVal10] = useState(0);

  // const resetSelect = () => {
  //   setVal1(0);
  //   setVal2(0);
  //   setVal3(0);
  //   setVal4(0);
  //   setVal5(0);
  //   setVal6(0);
  //   setVal7(0);
  //   setVal8(0);
  //   setVal9(0);
  //   setVal10(0);
  // };

  // const handleSent = async () => {
  //   try {
  //     setLoading(true);

  //     const response = await fetch(
  //       `https://obelabs.onrender.com/user/sidebar/sidebarrating`,
  //       {
  //         method: "post",
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           val1: Val1,
  //           val2: Val2,
  //           val3: Val3,
  //           val4: Val4,
  //           val5: Val5,
  //           val6: Val6,
  //           val7: Val7,
  //           val8: Val8,
  //           val9: Val9,
  //           val10: Val10,
  //           obj_id: props.institute_id,
  //           user_id: user_id,
  //           overall:
  //             Number(Val1) +
  //             Number(Val2) +
  //             Number(Val3) +
  //             Number(Val4) +
  //             Number(Val5) +
  //             Number(Val6) +
  //             Number(Val7) +
  //             Number(Val8) +
  //             Number(Val9) +
  //             Number(Val10),
  //         }),
  //       }
  //     );

  //     const result = await response.json();
  //     setLoading(false);
  //     if (result) {
  //       fetchData();
  //       resetSelect();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     //   resetSelect();

  //     setLoading(false);
  //   }
  // };

  // async function fetchData() {
  //   try {
  //     const response = await axios.get(
  //       `https://obelabs.onrender.com/user/sidebar/getsidebarrating/${props.institute_id}`
  //     );
  //     setData(response.data);

  //     if (response) {
  //       setRatingAverage(() => {
  //         if (response.data.length > 1) {
  //           const total = response.data.reduce((a, b) => {
  //             return a.overall + b.overall;
  //           });

  //           const avg = total / response.data.length;
  //           return avg;
  //         }
  //         if (response.data.length === 1) {
  //           return response.data[0].overall;
  //         }
  //       });
  //       return 0;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // useEffect(() => {
  //   fetchData();
  // }, []);

  return (
    <React.Fragment>
      <div className="rating-page pb-2">
        <div className="rate container-fluid px-mobile-0">
          
          <div className="d-flex review-tags-mobile" style={{ gap: "5px" }}>
            
            <div className='checkbox-container tag-btn px-md-1 px-4'>
              
              <label id='Excellent' onClick={props.handlebtn}>Excellent </label>
            </div>

            <div className='checkbox-container tag-btn px-md-1 px-4'>
              
              <label id='Favorable' onClick={props.handlebtn}>Favorable</label>
            </div>

            <div className='checkbox-container tag-btn px-md-1 px-4'>
              <label id='Great' onClick={props.handlebtn}>Great </label>
            </div>

            <div className='checkbox-container tag-btn px-md-1 px-4'>
              <label id='Satisfactory' onClick={props.handlebtn}>Satisfactory</label>
            </div>
          </div>
        </div>
        
      </div>
    </React.Fragment>
  );
};

export default Tags;
